import { http } from "../base"


export async function postBrief(formData) {
  for (let [key, value] of formData.entries()) {
    console.log(key, value);
  }
    try {
        const response = await http.post(
            `/tenant/save_brief`,
        formData,


    )
    return response
    } catch (error) {
        return error
    }
}
